export enum FileName {
  ALL = 'modules.data-management.filter.br-placeholder',
  REQUEST = 'modules.expert-tool.log-history.filter.fileName-request',
  RESPONSE = 'modules.expert-tool.log-history.filter.fileName-response',
  TRACE = 'modules.expert-tool.log-history.filter.fileName-trace',
}
